import { FormEvent } from 'react';
import { UseFormReturnType } from '@mantine/form';
import { Stack, TextInput } from '@mantine/core';
import { OnboardingSignupFormValues } from '../applySubmissionError';
import { WizardShell } from '../components/WizardShell';

type FrnStepProps = {
  form: UseFormReturnType<OnboardingSignupFormValues>;
  direction: 1 | -1;
  currentStepIndex: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
};

export function FrnStep({ form, onBack, onNext }: FrnStepProps) {
  const handleNext = (event?: FormEvent) => {
    event?.preventDefault();
    if (form.validateField('frn').hasError) return;
    onNext();
  };

  return (
    <WizardShell
      title="What is your FCA firm reference number?"
      onBack={onBack}
      onAction={handleNext}
      actionDisabled={!form.isValid('frn')}
    >
      <form onSubmit={handleNext}>
        <Stack gap="lg">
          <TextInput
            required
            label="FCA firm reference number"
            description="6 or 7 digit number"
            placeholder="e.g. 123456"
            inputMode="numeric"
            key={form.key('frn')}
            {...form.getInputProps('frn')}
            data-autofocus
          />
        </Stack>
      </form>
    </WizardShell>
  );
}
